const isRouteActive = (pathname, to) => pathname.split(':')[0] === to

export const isActive = (pathname, to) =>
  pathname
    ? Array.isArray(to)
      ? to.map((route) => isRouteActive(pathname, route)).some(Boolean)
      : isRouteActive(pathname, to)
    : false
